.root {
  display: grid;
  gap: 24px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    gap: 32px;
    padding: 32px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    gap: 32px;
    padding: 32px;
  }
}
